import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { Component, ContentChild, EventEmitter, Input, Output, TemplateRef } from "@angular/core";
import * as uuid from "uuid";

export type ListaDadItemChild<T> = { elem: ListaDadItem<T> | T, checked: boolean, index: number, dragDisabled: boolean, parentChild?: ListaDadItemChild<T>, parent?: ListaDadItem<T> };
export type ListaDadParam<T, K> = { elem: ListaDadItemChild<T>, index: K, subIndex?: K };
export type ListaDadCallBack<T, K> = ($event: ListaDadParam<T, K>) => void;
export type ListaDadItemChildren<T> = (ListaDadItemChild<T>)[];
export class ListaDadItem<T> {
	name: string;
	uId: string;
	children: ListaDadItemChildren<T>;
	parent: ListaDadItem<T>;
	child: ListaDadItemChild<T>;
	constructor(options: {
		name: string,
		children?: ListaDadItemChildren<T>,
		parent?: ListaDadItem<T>,
		child?: ListaDadItemChild<T>
	}) {
		this.name = options.name;
		this.uId = uuid.v4();
		this.children = options.children || [];
	}
	disable(): void {
		this.child.dragDisabled = true;
		this.propagateCheckStatus(this.child);
	}
	enable(): void {
		this.child.dragDisabled = false;
		this.propagateCheckStatus(this.child);
	}
	toggleDisable():void {
		if(this.child.dragDisabled){
			this.enable();
		}else{
			this.disable();
		}
	}
	moveItemInArray(finalPosition: number): void {
		if (this.child && this.child.parent && this.child.parent.children && this.parent.children.length > 1) {
			if (finalPosition < 0) {
				finalPosition = this.child.parent.children.length + finalPosition;
			}
			if (finalPosition >= 0) {
				moveItemInArray(this.child.parent.children, this.child.index, finalPosition);
			}
		}
	}
	addChild(item: T | ListaDadItem<T>): void {
		const child: ListaDadItemChild<T> = {
			elem: item,
			checked: true,
			dragDisabled: false,
			index: this.children.length,
			parent: this
		};
		this.children.push(child);
		if (child.elem instanceof ListaDadItem) {
			(child.elem as ListaDadItem<T>).parent = this;
			(child.elem as ListaDadItem<T>).child = child;
		}
		if (this.child) {
			this.children[child.index].parentChild = child;
		}
	}
	addChildren(items: (T | ListaDadItem<T>)[]) {
		items.forEach(item => this.addChild(item));
	}
	propagateCheckStatus(item: ListaDadItemChild<T>) {
		if (item.elem instanceof ListaDadItem) {
			if (item.elem.children && item.elem.children.length > 0) {
				for (let i = 0; i < item.elem.children.length; i++) {
					const child: ListaDadItemChild<T> = item.elem.children[i];
					child.checked = item.checked;
					child.dragDisabled = item.dragDisabled;
					if (child.elem instanceof ListaDadItem) {
						if (child.elem.uId !== item.elem.uId) {
							child.elem.propagateCheckStatus(child);
						}
					}
				}
			}
		}
		if (this.child) {
			this.child.checked = this.isOneChecked();
			this.child.dragDisabled = this.areAllDisabled();
		}
	}
	isOneChecked(): boolean {
		return this.children.some(child => child.checked === true);
	}
	areAllDisabled(): boolean {
		return !this.children.some(child => child.dragDisabled === false);
	}
	unwind(): T[] {
		let list: T[] = [];
		if (this.children) {
			for (let i = 0; i < this.children.length; i++) {
				if (this.children[i].checked) {
					if (this.children[i].elem instanceof ListaDadItem) {
						list = [...list, ...(this.children[i].elem as ListaDadItem<T>).unwind()];
					} else {
						list.push(this.children[i].elem as T);
					}
				}
			}
		}
		return list;
	}
	foreach(callback: (children: ListaDadItemChildren<T>, child: ListaDadItemChild<T>, childIndex: number) => void): void {
		this.children.forEach((val: ListaDadItemChild<T>, indexVal: number) => {
			if (val.elem instanceof ListaDadItem) {
				val.elem.foreach(callback);
			} else {
				callback(this.children, val, indexVal);
			}
		});
	}
}
@Component({
	selector: "app-lista-dad",
	templateUrl: "./lista-dad.component.html"
})

export class ListaDadComponent<
	T extends any,
	K extends string | number,
> {
	@Input("item") set inputItem(val: ListaDadItem<T> | T[]) {
		if (val !== undefined && val !== null) {
			this.itemIn = val;
			if (this.itemIn === undefined || this.itemIn === null) {

			}
		}
	};
	itemIn: ListaDadItem<T> | T[];
	@Input() parentItemIn?: ListaDadItem<T> | T[];

	@ContentChild('itemTemplate', { static: false, read: TemplateRef }) itemTemplate: TemplateRef<any> = null;
	get itemTemplateExists(): boolean {
		return this.templateIsUsed(this.itemTemplate);
	}


	public get dragDisabled(): boolean {
		return this.getDragDisabled(this.parentItemIn, this.itemIn);
	}
	getDragDisabled(parentItem, item): boolean {
		return !(parentItem && Array.isArray(parentItem));
	}

	public get parentItemId(): string {
		return this.getParentItemId(this.parentItemIn, this.itemIn);
	}
	public getParentItemId(parentItem, item): string {
		if (parentItem instanceof ListaDadItem) {
			return this.getDragDisabled(parentItem, item) ? '' : parentItem["elem"] ? parentItem["elem"].uId : parentItem.uId;
		}
		return null;
	}

	public get itemId(): string {
		return this.getItemId(this.parentItemIn, this.itemIn);
	}
	public getItemId(parentItem, item): string {
		if (item instanceof ListaDadItem) {
			return this.getDragDisabled(parentItem, item) ? '' : item["elem"] ? item["elem"].uId : item.uId;
		}
		return null;
	}

	public fireToggleCheck(parentItem, item: ListaDadItemChild<T>, event, indexItem: number): void {
		if (item && typeof item.checked !== "undefined") {
			const checkIsChanged: boolean = item.checked !== event.checked;
			item.checked = event.checked;
			item.parent.propagateCheckStatus(item);
			if (checkIsChanged) {
				this.emitOnCheckChange.emit(item);
			}
			this.fireOnChange();
		}
	}


	@Output("onChange") emitOnChange: EventEmitter<T[]>;
	@Output("onCheckChange") emitOnCheckChange: EventEmitter<ListaDadItemChild<T>>;
	@Output("afterDragDrop") emitAfterDragDrop: EventEmitter<ListaDadItemChild<T>>;

	constructor() {
		this.emitOnChange = new EventEmitter();
		this.emitOnCheckChange = new EventEmitter();
		this.emitAfterDragDrop = new EventEmitter();
	}

	getView(item, parentItem): string {
		if (item) {
			if (Array.isArray(item)) return "ARRAY";
			if (parentItem) {
				if (Array.isArray(parentItem)) return "ARRAYELEM";
			}
			return "ELEM";
		}
		return "NULL";
	}
	public fireOnChange(): void {
		const lista: T[] = (this.itemIn instanceof ListaDadItem) ? this.itemIn.unwind() : [...this.itemIn];
		console.log("fireOnChange", lista);
		this.emitOnChange.emit(lista);
	}

	public onDragDrop(event: CdkDragDrop<ListaDadItemChildren<T>>): void {
		console.log("onDragDropzz", event);
		if (event && event.previousIndex !== event.currentIndex) {
			if (event.container.data && event.container.data[event.previousIndex]) {
				if (event.container.data[event.previousIndex].elem instanceof ListaDadItem) {
					(event.container.data[event.previousIndex].elem as ListaDadItem<T>).moveItemInArray(event.currentIndex);
				} else {
					moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
				}
				for(let i=Math.min(event.previousIndex, event.currentIndex); i < event.container.data.length; i++){
					event.container.data[i].index = i;
				}
				this.emitAfterDragDrop.emit(event.container.data[event.currentIndex]);
				this.fireOnChange();
			}
		}

	}

	templateIsUsed(template: TemplateRef<any>): boolean {
		return template &&
			template.elementRef &&
			template.elementRef.nativeElement &&
			(template.elementRef.nativeElement as Element).innerHTML != "";

	}

}







